import React from 'react';

import '../styles/auth.css';

interface DividerProps {
  text?: string;
}

export const Divider: React.FC<DividerProps> = ({ text = 'OR' }) => (
  <div className="auth-divider">{text}</div>
);
